// @flow
import type { PassengerId } from "mmb/types/primitiveTypes"
import type { DateValue } from "mmb/components/DateField/DateField"

export const STATUS = {
  PENDING: "pending",
  DONE: "done",
}

export const REASONS = {
  INVALID_DOCUMENT: "invalid_document",
  INVALID_NAME: "invalid_name",
  INVALID_BIRTHDAY: "invalid_birthday",
}

export const REQUIRE_PID = [
  REASONS.INVALID_DOCUMENT,
  REASONS.INVALID_NAME,
  REASONS.INVALID_BIRTHDAY,
]

export const FIELDS = {
  FIRST_NAME: "firstname",
  MIDDLE_NAME: "middlename",
  LAST_NAME: "lastname",
  BIRTHDAY: "birthday",
  PASSPORT_NUMBER: "idNumber",
  PASSPORT_EXPIRY: "idExpiration",
}

export const FORM_FIELDS = [
  "passengers[].reason",
  "passengers[].id",
  "passengers[].pid",
  "passengers[].note",
  "passengers[].shouldShowMiddleName",
  `passengers[].${FIELDS.FIRST_NAME}`,
  `passengers[].${FIELDS.MIDDLE_NAME}`,
  `passengers[].${FIELDS.LAST_NAME}`,
  `passengers[].${FIELDS.BIRTHDAY}`,
  `passengers[].${FIELDS.PASSPORT_NUMBER}`,
  `passengers[].${FIELDS.PASSPORT_EXPIRY}`,
]

export const NOTE = {
  EMPTY: "empty",
  LATIN: "Name should be in Latin",
  CYRILLIC: "Please provide your name in Cyrilic Azbuka",
}

// types
// =====
export type Status = "pending" | "done"

export type Reason = "invalid_document" | "invalid_name" | "invalid_birthday"

export type Note = $Values<typeof NOTE>

export type Input = {
  id: number,
  pid?: PassengerId,
  status: Status,
  reason: Reason,
  created: number,
  fulfilled: ?number,
  note: Note,
  passport?: ?string,
}

export type FieldName = $Values<typeof FIELDS>

export type ExpirationDateValue = DateValue

export type BirthDateValue = {
  day: string,
  month: string,
  year: string,
}

export type FormField = {
  reason: Reason,
  id: number,
  pid: number,
  note: Note,
  shouldShowMiddleName: boolean,
  firstname: string,
  middlename: string,
  lastname: string,
  birthday: BirthDateValue,
  idNumber: string,
  idExpiration: ExpirationDateValue,
}

export type FormFields = Array<FormField>

export type DateRangeError = {
  t: string,
  values: {
    what: string,
    lower: number,
    upper: number,
  },
}

export type FormFieldError = {
  reason: null,
  id: null,
  pid: null,
  note: null,
  shouldShowMiddleName: null,
  firstname: ?string,
  middlename: ?string,
  lastname: ?string,
  birthday: ?string | ?DateRangeError,
  idNumber: ?string,
  idExpiration: ?string | ?DateRangeError,
}

export type PassengerPayload =
  | {
      pid: number,
      firstname: string,
      middlename?: string,
      lastname: string,
    }
  | {|
      pid: number,
      birthday: string,
    |}
  | {|
      pid: number,
      cardno: string,
      expiration: ?string,
    |}
